// extracted by mini-css-extract-plugin
export default {"input":"PasswordRecovery_input__NARs5","button":"PasswordRecovery_button__e2WEo","h3":"PasswordRecovery_h3__JtEMh","content":"PasswordRecovery_content__ZULua"};